var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFluentBathroom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconoir:bathroom"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M35 21.9323V26.9323C35 28.7004 34.2976 30.3961 33.0474 31.6463C31.7971 32.8966 30.1014 33.599 28.3333 33.599H11.6667C9.89856 33.599 8.20286 32.8966 6.95262 31.6463C5.70238 30.3961 5 28.7004 5 26.9323V22.9323C5 22.6671 5.10536 22.4127 5.29289 22.2252C5.48043 22.0376 5.73478 21.9323 6 21.9323H35ZM35 21.9323V11.9323C35 10.1642 34.2976 8.46849 33.0474 7.21825C31.7971 5.968 30.1014 5.26563 28.3333 5.26562H20M26.6667 33.599L28.3333 36.9323M13.3333 33.599L11.6667 36.9323",
    stroke: "#240b3b",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.6667 13.599H14.3333C13.7817 13.599 13.34 13.1523 13.4 12.6023C13.6433 10.3906 14.7717 5.26562 20 5.26562C25.2283 5.26562 26.3567 10.3906 26.6 12.6023C26.66 13.1523 26.2183 13.599 25.6667 13.599Z",
    stroke: "#240b3b",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluentBathroom);
export default __webpack_public_path__ + "static/media/fluent-bathroom.744cef459e4d3968a1a572b9498cac40.svg";
export { ForwardRef as ReactComponent };